import { render, staticRenderFns } from "./solicitudPersonalAprob.vue?vue&type=template&id=a3b86b2a&scoped=true"
import script from "./solicitudPersonalAprob.vue?vue&type=script&lang=js"
export * from "./solicitudPersonalAprob.vue?vue&type=script&lang=js"
import style0 from "./solicitudPersonalAprob.vue?vue&type=style&index=0&id=a3b86b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b86b2a",
  null
  
)

export default component.exports